<ckeditor [ngClass]="{'balloon-editor' : !showClassicEditor}" 
          [editor]="EditorBuild"
          [config]="defaultConfig" 
          (ready)="onReady($event)" 
          [data]="page?.unit.content">
</ckeditor>
<div *ngIf="showWordCount" class="bulb-word-count">
    <span transloco="contentEditor.words">words </span>: {{wordCount}}
</div>
